<template>
  <content-loader :height="110.5" :width="645">
    <circle cx="30" cy="30" r="30" />
    <rect x="90" y="15" rx="0" ry="0" width="555" height="95.5" />
    <polygon points="90,15 75,30 90,45" />
  </content-loader>
</template>

<script>
import ContentLoader from '@/components/contentLoaders/ContentLoader'

export default {
  components: {
    ContentLoader,
  },
}
</script>
